module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-by-10348a20d38bdde507431310edcd549d.svg";